import { QueryClient, useQuery, UseQueryResult } from '@tanstack/react-query';
import { type Observation } from '../../shared/types';
import { getObservations } from '../utilities/api';

export const queryKeys = {
    getObservations: () => ['observations', 'get'],
};

export const useObservations = (): UseQueryResult<Observation[], Error> => {
    return useQuery({ queryKey: queryKeys.getObservations(), queryFn: getObservations, retry: false, refetchInterval: 300000, refetchIntervalInBackground: true });
};

export const invalidateObservations = (queryClient: QueryClient): void => {
    queryClient.invalidateQueries({ queryKey: queryKeys.getObservations() });
};
